<template>
  <div>
    <div class="grid bg-white" v-if="!isReadOnlyUser">
      <h3 class="heading semi-bold title">Production Item Scan</h3>
      <div class="grid-title">
        <div class="row">
          <div class="col-md-4">
            <div id="choose-scanning-station" class="form-group">
              <label for="">Select Station</label>
              <select class="form-control" v-model="status">
                <option :value="null">Please Select Station</option>
                <option value="stitching">Stitching</option>
                <option value="qc">QC</option>
                <option value="packaging">Packaging</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="grid-body">
        <div class="row">
          <form id="scan-order-number-input" @submit.prevent="submit()">
            <div class="col-md-12">
              <input
                type="text"
                v-model="barcode"
                class="form-control scan-item"
              />
            </div>
            <div class="col-md-12">
              <br />
              <button type="submit" class="btn btn-lg btn-block btn-primary">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>

      <div id="error-message" class="grid-body text-center">
        <h1 class="text-bold message">{{ message }}</h1>
        <br /><br />
      </div>
    </div>
    <div class="grid bg-white" v-else>
      <div class="grid-body">
        <h4>
          You don't have the privilege to do this action, please contact an
          administrator.
        </h4>
      </div>
    </div>
    <div class="loading">
      <i class="fa fa-circle-o-notch fa-spin"></i>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isReadOnlyUser: false,
      message: null,
      barcode: null,
      status: null,
    };
  },
  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    $(".scan-item").focus();
  },
  methods: {
    submit() {
      this.scanItemNumber(this.barcode);
    },

    async scanItemNumber(barcode) {
      if (!barcode) {
        Swal.fire({
          title: "ERROR",
          text: "Invalid order number",
          type: "warning",
        });
        return false;
      }
      if (this.checkStation()) {
        $(".loading").show();

        try {
          let res = await axios.post("production_items/scan/" + barcode, {
            status: this.status,
          });
          if (res) {
            this.message = barcode;
            toastr.success("success");
          }
        } catch (err) {
          console.log(err);
          this.message = barcode;
          let message = err.response.data.message;
          Swal.fire({
            title: "ERROR",
            text: message,
            type: "warning",
          });
        }

        $(".loading").hide();
        this.barcode = null;
      }
    },

    checkStation() {
      if (this.status == null) {
        Swal.fire({
          title: "ERROR",
          text: "Please Select Station",
          type: "warning",
        });
        return false;
      }
      return true;
    }
  },
};
</script>

<style scoped>
.scan-item {
  font-size: 90px !important;
  height: 200px;
}

.btn-lg {
  height: 50px;
  font-size: 25px;
}

.loading {
  font-size: 150px;
  position: absolute;
  top: 20%;
  text-align: center;
  width: 100%;
  left: 0px;
  right: 0px;
  display: none;
}

.message {
  font-size: 90px;
}
.title {
  padding: 20px;
}
</style>
